<template>
    <b-row class="eventcard">
        <b-col class="img-sd" v-bind:style='{ backgroundImage: "url(" + imgUrl + ")", }'>
        </b-col>
        <b-col class="firstborder-right">
            <div class="font16 mt-3 font-weight-bold">
                {{eventName}}
            </div>
            <p class="font12">
                <b-icon style="color:#F7B131" font-scale="1" icon="geo"></b-icon> {{locationStatus}}
            </p>
            <p class="font12" :inner-html.prop="eventDesc | truncate(100)"></p>
            <p class="culture-primary font14 font-weight-bold">
                {{feeStatus == 'Paid'?'': feeStatus}} <span v-if="price !== null"> ${{price}}</span>
            </p>
        </b-col>
        <b-col class="secondborder-right">
            <p class="time-frame font12">
                <strong>From</strong>: {{fromTime}}
            </p>
            <p class="time-frame font12">
                <strong>To</strong>: {{toTime}}
            </p>
            <p class="font12 flex mt-2">
                <span class="mr-3">
                    <b-icon style="color:#F7B131" font-scale="1" icon="geo-alt"></b-icon>
                </span> <span> {{location}}</span>
            </p>
            <router-link :to="{ name: torouteName, params: {id: routeId} }" v-if="showBookBtn"
                class="foot btn btn-warning btn-book font10">
                Details <b-icon font-scale="0.99" icon="arrow-right"></b-icon>
            </router-link>
        </b-col>
        <b-col style="padding-right:0 !important">
            <div class="host-img" v-bind:style='{ backgroundImage: "url(" + hostImg + ")", }'></div>
            <div class="card inner-card text-center">
                <p class="font12 mb-2 mt-3">
                    {{hostName}}
                </p>
                <div>
                    <b-form-rating readonly show-value inline size="sm" v-model="starRating"></b-form-rating>
                </div>
                <button v-if="showProfileBtn" @click="handleProfile" class="btn btn-secondary font10">
                    View Profile <b-icon font-scale="0.99" icon="arrow-right"></b-icon>
                </button>

            </div>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'event-card',
    props: ['eventName', 'imgUrl', 'showBookBtn', 'torouteName', 'routeId', 'showProfileBtn', 'hostImg', 'feeStatus', 'locationStatus', 'eventDesc', 'price', 'fromTime', 'toTime', 'location', 'hostName', 'starRating'],
    methods: {
        handleProfile() {
            this.$emit('handleProfile')
        }
    }
}
</script>

<style scoped>
.time-frame {
    background: rgba(247, 177, 49, 0.15);
    border-radius: 16px;
    padding: 2px 13px;
    text-transform: uppercase;
    margin-top: 10px
}

.foot {
    position: absolute;
    bottom: 15px;
}

.img-sd {
    padding-left: 0 !important;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 16px 0 0 16px;
}

.host-img {
    height: 100px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 0 16px 0 0;
}

.eventcard {
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    border: none !important;
    background: #FCFCFC;
    position: relative;
    margin: 35px auto;
}

.eventcard:hover {
    border: 1px solid #F7B131 !important
}

.firstborder-right:after {
    content: "";
    position: absolute;
    top: 7%;
    left: calc(98% + 4px);
    width: 2px;
    height: 80%;
    background: rgba(86, 92, 99, 0.2);
}

.secondborder-right:after {
    content: "";
    position: absolute;
    top: 7%;
    left: calc(98% + 7px);
    width: 2px;
    height: 80%;
    background: rgba(86, 92, 99, 0.2);
}

.inner-card {
    background: #FCFCFC;
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12);
    border-radius: 0 0 16px 0;
    border: none !important;
}

.btn-secondary {
    margin: 13px 20px;
}

.btn-book {
    margin-top: 30px
}

@media screen and (min-width: 1400px) {
    .firstborder-right:after {
        content: "";
        position: absolute;
        top: 7%;
        left: calc(98% + 2px);
        width: 2px;
        height: 80%;
        background: rgba(86, 92, 99, 0.2);
    }

    .secondborder-right:after {
        content: "";
        position: absolute;
        top: 7%;
        left: calc(98% + 7px);
        width: 2px;
        height: 80%;
        background: rgba(86, 92, 99, 0.2);
    }
}
</style>
